import { AbstractControl } from "@angular/forms";

export function zipCodeValidator(firstDigitNotZeroValidation?: boolean) {
	return (control: AbstractControl): { firstDigitNotZero?: boolean; lengthFourDigits?: boolean } | null => {
		const numberNotZero = /^[1-9]\d*$/;
		const lengthFourDigits = /^[0-9]{4}$/;

		if (control.value) {
			const value = control.value.toString();

			if (!value.charAt(0).match(numberNotZero) && firstDigitNotZeroValidation) {
				return { firstDigitNotZero: false };
			}
			if (!value.match(lengthFourDigits)) {
				return { lengthFourDigits: false };
			}
		}

		return null;
	};
}
